import React, {useState} from 'react';
import '../BookingOverlay.css'
import {IApiBusinessProfileProto, IScheduledClassProto} from "../../../compiled";
import {BookingFlowPage} from "../BookingFlowPage";
import {ClassSchedule} from "./ClassSchedule";
import {SelectedBooking} from "../BookingFlow";
import {useSearchParams} from "react-router-dom";


type Props = {
  businessProfile: IApiBusinessProfileProto,
  onChosen: (booking: SelectedBooking) => void;
}

/**
 * Booking flow for classes. There is a lot less to choose here; you just see a filterable
 * list of class events, and you choose one.
 */
export const ClassBookingFlow = (props: Props) => {

  const [searchParams] = useSearchParams();
  const version = searchParams.get('v') ?? undefined; // this is for previewing your flow
  
  const businessProfile = props.businessProfile;

  const [selectedClass, setSelectedClass] = useState<IScheduledClassProto>();

  if (!selectedClass) {
    return <BookingFlowPage
        title={`Book with ${businessProfile?.proto?.businessName}`}
        content={<ClassSchedule businessId={businessProfile.businessId as string}
                                version={version}
                                onSelected={c => {
                                  setSelectedClass(c);
                                  props.onChosen({
                                    class: c
                                  })
                                }}/>
        }/>
  }
  
  return <></>
}